import * as types from './index';

export const getActionRequiredData = (data) =>{
    return {
        type: types.DASHBOARD_ACTION_REQUIRED_LIST, 
        data
    }
}

export const getClientActionRequiredData = (data) =>{
    return {
        type: types.DASHBOARD_CLIENT_ACTION_REQUIRED_LIST, 
        data
    }
}

export const chartData = (data) =>{
    return {
        type: types.DASHBOARD_CHART_DATA_LIST, 
        data
    }
}

export const clientChartData = (data) =>{
    return {
        type: types.DASHBOARD_CLIENT_CHART_DATA_LIST, 
        data
    }
}

export const shiftTimeChangeRequestCountAction = (data) =>{
    return {
        type: types.SHIFT_TIME_CHANGE_REQUEST_COUNT, 
        data
    }
}